module.exports = __webpack_public_path__ + "static/media/level3_q4_correct.24e977bd.png";